import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/gi-logo-mobile.png'


const _withScopeId = n => (_pushScopeId("data-v-673b069c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  style: {"padding":"14rem"},
  class: "red-background"
}
const _hoisted_2 = { class: "p-d-flex p-justify-around p-pt-3 red-background" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Logo",
  class: "logo-mobile"
}, null, -1))
const _hoisted_4 = { class: "p-d-flex p-flex-column red-background" }
const _hoisted_5 = { class: "influencer-navigation" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Sidebar = _resolveComponent("Sidebar")!

  return (_openBlock(), _createBlock(_component_Sidebar, {
    visible: _ctx.op,
    "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.op) = $event)),
    position: "top",
    style: {"height":"auto","padding":"0px"}
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", {
            class: "material-icons close-button-mobile",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
          }, "close")
        ]),
        _createElementVNode("section", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "headers",
                href: "#about",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close'))),
                onTouchstart: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
              }, "About GameInfluencer.IO", 32)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "headers",
                href: "#platform",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close'))),
                onTouchstart: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close')))
              }, "Platform Services", 32)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "headers",
                href: "#our-case-studies",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('close'))),
                onTouchstart: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('close')))
              }, "Case Studies", 32)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "headers",
                href: "#testimonials",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('close'))),
                onTouchstart: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('close')))
              }, "Testimonials", 32)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "headers",
                href: "#faq",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('close'))),
                onTouchstart: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('close')))
              }, "FAQ", 32)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("button", {
                class: "login-button-mobile",
                onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$router.push({ name: 'login' })))
              }, "Login / Register")
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}